var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('passiveinventory',{key:_vm.key,attrs:{"passiveinventory":_vm.passiveInventory,"stocktypes":_vm.stockTypes,"tableloading":_vm.tableLoading},on:{"refresh":function($event){return _vm.getPassiveInventory()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }